import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { AppService } from 'app/services/app/app.service';

@Component({
  selector: 'app-form-error',
  template: `
    <ng-container *ngIf="control?.invalid && control?.touched">
        <!-- Mostrar solo el primer error -->
        <mat-error *ngIf="!showAll">
            {{ getErrorMessages()[0] }}
        </mat-error>

        <!-- Mostrar todos los errores -->
        <ng-container *ngIf="showAll">
            <mat-error *ngFor="let error of getErrorMessages()">
            {{ error }}
            </mat-error>
        </ng-container>
    </ng-container>
  `
})
export class FormErrorComponent {
  @Input() control!: AbstractControl | null;
  @Input() messages: { [key: string]: string } = {};
  @Input() showAll = true;

  
  constructor(public appService: AppService) {

  }
  

  getErrorMessages(): string[] {
    if (!this.control || !this.control.errors) return [];

    const errors: string[] = [];

    if (this.control.hasError('required')) {
      errors.push(this.messages['required'] || 'Este campo es obligatorio');
    }
    if (this.control.hasError('minlength')) {
      const requiredLength = this.control.getError('minlength').requiredLength;
      errors.push(this.messages['minlength'] || `Debe tener al menos ${requiredLength} caracteres`);
    }
    if (this.control.hasError('maxlength')) {
      const maxLength = this.control.getError('maxlength').requiredLength;
      errors.push(this.messages['maxlength'] || `No puede tener más de ${maxLength} caracteres`);
    }
    if (this.control.hasError('email')) {
      errors.push(this.messages['email'] || 'Debe ser un email válido');
    }
    if (this.control.hasError('missingLowercase')) {
      errors.push(this.messages['missingLowercase'] || this.appService.getTraduccion('password.errors.missingLowercase'));
    }
    if (this.control.hasError('missingUppercase')) {
      errors.push(this.messages['missingUppercase'] || this.appService.getTraduccion('password.errors.missingUppercase'));
    }
    if (this.control.hasError('missingDigit')) {
      errors.push(this.messages['missingDigit'] || this.appService.getTraduccion('password.errors.missingDigit'));
    }
    if (this.control.hasError('missingSpecial')) {
      errors.push(this.messages['missingSpecial'] || this.appService.getTraduccion('password.errors.missingSpecial'));
    }
    if (this.control.hasError('min')) {
      errors.push(this.messages['min'] || this.appService.getTraduccion('password.errors.min'));
    }
    if (this.control.hasError('max')) {
      errors.push(this.messages['max'] || this.appService.getTraduccion('password.errors.max'));
    }


    if (errors.length === 0 && this.messages['default']) {
      errors.push(this.messages['default']);
    }

    return errors;
  }
}
